import apiClient from "@/services/axios";

export async function put(venueId, generalInfo) {
  var response = await apiClient.put("/venue/info/general", generalInfo, {
    headers: {
      venueId: venueId
    }
  });
  if (response) {
    return response.data;
  }

  throw new Error("Unable to update general info.");
}
